import { SvgIcon } from "@mui/material";

export default function ShareSvg({ sx }) {
    return (
        <SvgIcon
            viewBox="0 0 24 24"
            sx={{ ...sx, width: 24, height: 24, fill: "none" }}
        >
            <path
                d="M17.3333 8.00008C18.8061 8.00008 20 6.80617 20 5.33341C20 3.86066 18.8061 2.66675 17.3333 2.66675C15.8606 2.66675 14.6667 3.86066 14.6667 5.33341C14.6667 6.80617 15.8606 8.00008 17.3333 8.00008Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.66667 14.6666C8.13943 14.6666 9.33333 13.4727 9.33333 11.9999C9.33333 10.5272 8.13943 9.33325 6.66667 9.33325C5.19391 9.33325 4 10.5272 4 11.9999C4 13.4727 5.19391 14.6666 6.66667 14.6666Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.3333 21.3333C18.8061 21.3333 20 20.1394 20 18.6667C20 17.1939 18.8061 16 17.3333 16C15.8606 16 14.6667 17.1939 14.6667 18.6667C14.6667 20.1394 15.8606 21.3333 17.3333 21.3333Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.33333 13.3333L14.6667 17.3333"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.6667 6.66675L9.33333 10.6667"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
}
